export default function ArticleHeader({ title, excerpt, className }) {
	return (
		<div className={className}>
			<h1
				className="style-h2 text-balance [@media(max-width:767px)]:[&_br]:hidden mb-[4rem] sm:mb-[3rem] md:mb-[4rem]"
				dangerouslySetInnerHTML={{ __html: title?.toString()?.replaceAll('\n', '<br />') }}
			/>

			<p className="style-body--lg md:style-body--xl">{excerpt}</p>
		</div>
	)
}
